import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';

const MintContent = ({
  className
}) => /*#__PURE__*/React.createElement("div", {
  className: classNames(className, styles.container)
}, /*#__PURE__*/React.createElement("p", {
  className: styles.title
}, "What are \"Not Mint\" NFTs?"), /*#__PURE__*/React.createElement("p", {
  className: styles.body
}, "Mint to convert this item into an NFT and start trading the item on the Marketplace."));

export default MintContent;